import React, { useState, useEffect, useRef, useContext } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import InputField from 'Components/Input/InputField';
import ComboBox from 'Components/ComboBox/ComboBox';
import EmployesDayAllocated from './EmployesDayAllocated/EmployesDayAllocated';
import Button from 'Components/Button/Button';
import { AuthContext } from 'Contexts/auth';
import ExternalProduction from '../ExternalProductionPanel/ExternalProduction';
import CreateProductFromDocument from '../CreateProductFromDocument/CreateProductFromDocument';
import useDebouncedValue from 'Components/UseDebouncedValue/useDebouncedValue';
import useUpdateEffect from 'Components/UseUpdateEffect/useUpdateEffect';

const Production = ({
    onUpdateProductionIdSelected,
    onUpdateReloadProductionList,
    onUpdateDecreaseProductionPanel,
    onUpdateProductionDaysIdSelecteds,
    productionIdSelecteds,
    reloadProductionList,
    decreaseProductionPanel,
    decreaseProductionPanelDay,
    allowedAdvancedModule,
    onUpdateShowEmployesDayAllocatedPanel,
    showEmployesDayAllocatedPanel,
    showExternalProduction,
    onUpdateShowExternalProduction
}) => {
    const { user } = useContext(AuthContext);
    const allowedExternalModule = user.module == 'OCMT_PRD_QTRZ' || user.module == 'OCMT_PRD_BLCT_QTRZ';

    const [productCode, setProductCode] = useState(null);
    const [idProduction, setIdProduction] = useState(null);
    const [productionOrder, setProductionOrder] = useState(null);
    const [quantityPieces, setQuantityPieces] = useState(null);
    const [internalMinPerPieces, setInternalMinPerPieces] = useState(null);
    const [minPerPieces, setMinPerPieces] = useState(null);
    const [totalMinPerPieces, setTotalMinPerPieces] = useState(null);
    const [totalMinutes, setTotalMinutes] = useState(null);
    const [dateReceived, setDateReceived] = useState(null);
    const [leadTime, setLeadTime] = useState(null);
    const [dateExpectedReturn, setDateExpectedReturn] = useState(null);
    const [dateRealReturn, setDateRealReturn] = useState(null);
    const [statusId, setStatusId] = useState(null);
    const [observation, setObservation] = useState(null);
    const [qtdPiecesHour, setQtdPiecesHour] = useState(null);

    const [completedPieces, setCompletedPieces] = useState(null);
    const [pendentPieces, setPendentPieces] = useState(null);
    const [workedMinutes, setWorkedMinutes] = useState(null);
    const [minValueWorked, setMinValueWorked] = useState(null);
    const [totalValueReceivable, setTotalValueReceivable] = useState(null);
    const [minValueReceivable, setMinValueReceivable] = useState(null);

    const [expectedQuantityPeople, setExpectedQuantityPeople] = useState(null);
    const [pricePerPiece, setPricePerPiece] = useState(null);
    const [realQuantityPeople, setRealQuantityPeople] = useState(null);
    const [expectedProductionDays, setExpectedProductionDays] = useState(null);
    const [realProductionDays, setRealProductionDays] = useState(null);
    const [dsProduct, setDsProduct] = useState(null);
    const [isVisibleOnlyProductionCosts, setIsVisibleOnlyProductionCosts] = useState(false);

    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [loadingProductionPanel, setLoadingProductionPanel] = useState(null);
    const [recordsProductByUserId, setRecordsProductByUserId] = useState(null);
    const [attributesDetailProductionPanel, setAttributesDetailProductionPanel] = useState(null);
    const [statusList, setStatusList] = useState(null);
    const [isBalanced, setIsBalanced] = useState(false);

    const [productCodeFilter, setProductCodeFilter] = useState(null);
    const debouncedProductCodeFilter = useDebouncedValue(productCodeFilter);
    const [showCreateProductFromDocument, setShowCreateProductFromDocument] = useState(false);
    const [statusFilterSelected, setStatusFilterSelected] = useState(null);

    const readOnlyAttributes = !(inserting || updating);
    const itemsStatusOptions = OptionsDataByAttributePath(statusList, ['description'], null, true);

    const [dtStartFilter, setDtStartFilter] = useState(() => {
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() - 7);
        return futureDate;
    });
    const [dtFinishFilter, setDtFinishFilter] = useState(() => {
        const futureDate = new Date();
        futureDate.setDate(futureDate.getDate() + 7);
        return futureDate;
    });

    useEffect(() => {
        callToSetVisiblePrices()
    }, []);

    async function callToSetVisiblePrices() {
        const disableField = await ExecuteAxios.api('get', `/profile/disable-fields-production-by-profile/`)
        setIsVisibleOnlyProductionCosts(!disableField)
    };

    const attributeList = [
        { name: "id", value: idProduction, setter: setIdProduction },
        { name: "textColor", value: 'green' },
        { name: "productCode", value: productCode, setter: setProductCode, readOnly: isBalanced, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay, onBlur: onBlurProductCode, searchMethod: searchProducts },
        { name: "productionOrder", value: productionOrder, setter: setProductionOrder, readOnly: isBalanced, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "quantityPieces", value: quantityPieces, setter: setQuantityPieces, readOnly: isBalanced, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay, onBlur: onBlurQuantityPieces },
        { name: "internalMinPerPieces", value: internalMinPerPieces, setter: setInternalMinPerPieces, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "minPerPieces", value: minPerPieces, setter: setMinPerPieces, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "totalMinPerPieces", value: totalMinPerPieces, setter: setTotalMinPerPieces, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "totalMinutes", value: totalMinutes, setter: setTotalMinutes, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "pricePerPiece", value: pricePerPiece, setter: setPricePerPiece, isVisible: isVisibleOnlyProductionCosts, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay, onBlur: onBlurPricePerPiece },
        { name: "expectedQuantityPeople", value: expectedQuantityPeople, setter: setExpectedQuantityPeople, readOnly: isBalanced, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay, onBlur: onBlurExpectedQuantityPeople },
        { name: "realQuantityPeople", value: realQuantityPeople, setter: setRealQuantityPeople, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "expectedProductionDays", value: expectedProductionDays, setter: setExpectedProductionDays, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay, width: '220px' },
        { name: "realProductionDays", value: realProductionDays, setter: setRealProductionDays, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay, width: '220px' },
        { name: "dsProduct", value: dsProduct, setter: setDsProduct, width: '280px', cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "dateReceived", value: dateReceived, setter: setDateReceived, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay, onBlur: onBlurDateReceived },
        { name: "leadTime", value: leadTime, setter: setLeadTime, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "dateExpectedReturn", value: dateExpectedReturn, setter: setDateExpectedReturn, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "dateRealReturn", value: dateRealReturn, setter: setDateRealReturn, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "statusId", value: statusId, setter: setStatusId, comboboxOptions: itemsStatusOptions, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "observation", value: observation, setter: setObservation, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "qtdPiecesHour", value: qtdPiecesHour, setter: setQtdPiecesHour, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "username", value: username, setter: setUsername, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "completedPieces", value: completedPieces, setter: setCompletedPieces, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "pendentPieces", value: pendentPieces, setter: setPendentPieces, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "workedMinutes", value: workedMinutes, setter: setWorkedMinutes, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "minValueWorked", value: minValueWorked, setter: setMinValueWorked, isVisible: isVisibleOnlyProductionCosts, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "totalValueReceivable", value: totalValueReceivable, setter: setTotalValueReceivable, isVisible: isVisibleOnlyProductionCosts, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay },
        { name: "minValueReceivable", value: minValueReceivable, setter: setMinValueReceivable, isVisible: isVisibleOnlyProductionCosts, cursor: 'pointer', onDoubleClick: setDecreaseProductionPanelDay }
    ];

    const subtitlesStyle = {
        padding: "5px",
        cursor: 'default'
    };

    function getColorStyle(valueToDisplay) {
        let colorStyle;
        if (valueToDisplay === 1) {
            colorStyle = { backgroundColor: 'purple' };
        } else if (valueToDisplay === 2) {
            colorStyle = { backgroundColor: 'rgb(57, 57, 249)' };
        } else if (valueToDisplay === 3) {
            colorStyle = { backgroundColor: 'green' };
        }

        return (
            <div
                style={{
                    width: '15px',
                    height: '15px',
                    borderRadius: '50%',
                    display: 'inline-block',
                    ...colorStyle
                }}
            ></div>
        )
    }

    function getSubtitlesContent() {
        return (
            <div style={{ backgroundColor: '#f5f5f5' }}>
                <div style={subtitlesStyle}>
                    {getColorStyle(1)}
                    <span style={{ marginLeft: "10px" }}>Aguardando</span>
                </div>
                <div style={subtitlesStyle}>
                    {getColorStyle(2)}
                    <span style={{ marginLeft: "10px" }}>Em produção</span>
                </div>
                <div style={subtitlesStyle}>
                    {getColorStyle(3)}
                    <span style={{ marginLeft: "10px" }}>Concluído</span>
                </div>
            </div>
        );
    }
    const [showSubtitles, setShowSubtitles] = useState(false);

    const toggleSubtitles = () => {
        setShowSubtitles(!showSubtitles);
    };

    const subtitlesStylePanel = {
        display: 'flex',
        width: '100%',
        position: 'relative'
    };

    function getButtonToShowSubtitles() {
        return (
            <div style={{ ...subtitlesStylePanel, background: '#f5f5f5' }}>
                <div style={{ position: 'absolute', bottom: '0px' }}>
                    {showSubtitles && (
                        <div className="balloon-cost-per-day">
                            {getSubtitlesContent()}
                        </div>
                    )}
                    <div className="title-balloon-cost-per-day"
                        onClick={toggleSubtitles}
                    >
                        Legenda
                    </div>
                </div>
            </div>
        );
    }

    // Lookup da referência: últimos 20 produtos cadastrados, filtrando por código/descrição
    async function searchProducts(search) {
        const parameters = { search: search || null }
        const products = await ExecuteAxios.api('get', `/product/get-product-lookup/`, { params: parameters })
        return (products || []).map(product => ({ value: product.productCode, description: product.dsProduct }))
    };

    async function onBlurProductCode() {
        callToSetDsProduct()
        callToSetInternalMinPerPieces()
        callToSetTotalMinPerPieces()
    };

    async function callToSetDsProduct() {
        if (productCode) {
            const parameters = { productCode: productCode }
            const productDescription = await ExecuteAxios.api('get', `/production/if-product-exists-get-describe-product/`, { params: parameters })
            setDsProduct(productDescription)
        }
    };

    async function callToSetInternalMinPerPieces() {
        if (productCode) {
            const parameters = { productCode: productCode }
            const minutesPerPiece = await ExecuteAxios.api('get', `/production/get-internal-minutes-per-piece-of-product/`, { params: parameters })
            setInternalMinPerPieces(minutesPerPiece)
            setMinPerPieces(minutesPerPiece)
        }
    };

    async function callToSetTotalMinPerPieces() {
        if (productCode) {
            const parameters = { productCode: productCode }
            const totalMinutesPerPiece = await ExecuteAxios.api('get', `/production/get-total-minutes-per-piece-of-product/`, { params: parameters })
            setTotalMinPerPieces(totalMinutesPerPiece)
        }
    };

    async function onBlurQuantityPieces() {
        callToSetTotalMinutes()
        callToSetTotalValueReceivable()
        callToSetMinValueReceivable()
        callToSetExpectedProductionDays()
        callToSetExpectedReturnDay()
    };

    async function onBlurPricePerPiece() {
        callToSetTotalMinutes()
        callToSetTotalValueReceivable()
        callToSetMinValueReceivable()
        if (!allowedAdvancedModule) {
            callToSetPiecesHours()
        }
    };

    async function callToSetPiecesHours() {
        if (pricePerPiece) {
            const parameters = { pricePerPiece: pricePerPiece }
            const quantity = await ExecuteAxios.api('get', `/production/get-amount-pieces-per-hour/`, { params: parameters })
            setQtdPiecesHour(quantity)
        }
    };

    async function callToSetTotalMinutes() {
        if (quantityPieces && internalMinPerPieces) {
            const parameters = { quantityPieces: quantityPieces, internalMinPerPieces: internalMinPerPieces }
            const totalMinutes = await ExecuteAxios.api('get', `/production/get-total-minutes-production/`, { params: parameters })
            setTotalMinutes(totalMinutes)
        }
    };

    async function callToSetTotalValueReceivable() {
        if (quantityPieces && pricePerPiece) {
            const parameters = { quantityPieces: quantityPieces, pricePerPiece: pricePerPiece }
            const totalValueReceivable = await ExecuteAxios.api('get', `/production/get-total-value-receivable/`, { params: parameters })
            setTotalValueReceivable(totalValueReceivable)
        }
    };

    async function callToSetMinValueReceivable() {
        if (quantityPieces && internalMinPerPieces && pricePerPiece) {
            let parameters = { quantityPieces: quantityPieces, internalMinPerPieces: internalMinPerPieces, pricePerPiece: pricePerPiece }
            const minValueReceivable = await ExecuteAxios.api('get', `/production/get-minute-value-receivable/`, { params: parameters })
            setMinValueReceivable(minValueReceivable)
        }
    };

    async function onBlurDateReceived() {
        callToSetExpectedReturnDay()
    };

    async function onBlurExpectedQuantityPeople() {
        callToSetExpectedProductionDays()
        callToSetExpectedReturnDay()
    };

    async function callToSetExpectedProductionDays() {
        if (quantityPieces && internalMinPerPieces && expectedQuantityPeople) {
            const parameters = {
                qtdPeople: expectedQuantityPeople,
                quantityPieces: quantityPieces,
                internalMinPerPieces: internalMinPerPieces
            }
            const productDescription = await ExecuteAxios.api('get', `/production/get-expected-production-days/`, { params: parameters })
            setExpectedProductionDays(productDescription)
        }
    };

    async function callToSetExpectedReturnDay() {
        if (dateReceived) {
            const parameters = {
                qtdPeople: expectedQuantityPeople,
                dataReceived: dateReceived,
                quantityPieces: quantityPieces,
                internalMinPerPieces: internalMinPerPieces,

            }
            const expectedReturn = await ExecuteAxios.api('get', `/production/get-date-expected-return/`, { params: parameters })
            setDateExpectedReturn(expectedReturn)
        }
    };

    function setDecreaseProductionPanelDay() {
        if (productionIdSelecteds && productionIdSelecteds.length === 1 && allowedAdvancedModule) {
            onUpdateDecreaseProductionPanel(!decreaseProductionPanel)

            if (decreaseProductionPanel) {
                onUpdateReloadProductionList(true)
            }
        }
    }

    useEffect(() => {
        if (!reloadProductionList || reloadProductionList.length === 0) {
            return
        }
        onUpdateReloadProductionList(false)
        getProductionRecords()
        if (productionIdSelecteds && productionIdSelecteds.length === 1) {
            fetchDataDetail(productionIdSelecteds[0]);
        }
    }, [reloadProductionList])

    useEffect(() => {
        if (dtFinishFilter) {
            getProductionRecords();
        }
    }, [dtFinishFilter]);

    useEffect(() => {
        if (dtStartFilter) {
            getProductionRecords();
        }
    }, [dtStartFilter]);

    useEffect(() => {
        if (statusFilterSelected) {
            getProductionRecords();
        }
    }, [statusFilterSelected]);

    // Consulta só quando o usuário para de digitar; também recarrega ao limpar o filtro
    useUpdateEffect(() => {
        getProductionRecords();
    }, [debouncedProductCodeFilter]);

    useEffect(() => {
        if ((!productionIdSelecteds || productionIdSelecteds.length != 1) && updating) {
            setUpdating(false)
        }

        if (!productionIdSelecteds || productionIdSelecteds.length > 1) {
            onUpdateProductionIdSelected([])
        }
    }, [inserting, updating]);


    useEffect(() => {
        onUpdateProductionDaysIdSelecteds([])
        if (productionIdSelecteds && productionIdSelecteds.length === 1) {
            fetchDataDetail(productionIdSelecteds[0]);
        } else {
            fetchDataDetail(null)
            setIsBalanced(null)
        }
    }, [productionIdSelecteds]);

    useEffect(() => {
        const onReady = async () => {
            await callToSetStatusList();
        };

        onReady();
    }, []) // lista fixa: carrega uma vez ao abrir a tela

    async function callToSetStatusList() {
        const statusList = await ExecuteAxios.api('get', `/production/get-production-status-list/`);
        setStatusList(statusList);
    }

    const productionPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        zIndex: '20',
        height: '100%',
    };

    const requestQueue = useRef([]);
    const isProcessing = useRef(false);
    const lastParamsRef = useRef(null);
    const activeController = useRef(null);

    async function enqueueProductionRequest(params) {
        const sameAsLast = JSON.stringify(lastParamsRef.current) === JSON.stringify(params);

        const alreadyInQueue = requestQueue.current.some(
            p => JSON.stringify(p) === JSON.stringify(params)
        );

        // Se os parâmetros são iguais ao último e já está em execução, ou já está na fila, não adiciona
        if ((isProcessing.current && sameAsLast) || alreadyInQueue) {
            return;
        }

        requestQueue.current.push(params);
        processQueue();
    }

    async function processQueue() {
        if (isProcessing.current || requestQueue.current.length === 0) return;

        isProcessing.current = true;

        const parameters = requestQueue.current.shift();
        lastParamsRef.current = parameters;

        const controller = new AbortController();
        activeController.current = controller;

        setLoadingProductionPanel(true);

        try {
            const products = await ExecuteAxios.api('get', `/production/get-production-grid/`, {
                params: parameters,
                signal: controller.signal,
            });

            setRecordsProductByUserId(products);
            RemoveIdsNotFound.remove(products, onUpdateProductionIdSelected, productionIdSelecteds);
        } catch (err) {
            if (err.name === 'CanceledError' || err.name === 'AbortError') {
                console.log('Requisição cancelada');
            } else {
                console.error(err);
            }
        } finally {
            setLoadingProductionPanel(false);
            isProcessing.current = false;
            processQueue(); // Continua com o próximo
        }
    }

    function getProductionRecords() {
        enqueueProductionRequest({
            startDateFilter: dtStartFilter,
            endDateFilter: dtFinishFilter,
            productCode: debouncedProductCodeFilter || null,
            statusId: statusFilterSelected,
        });

    }

    const fetchDataDetail = async (productionIdSelected) => {
        const parameters = { id: productionIdSelected ? productionIdSelected : 0 }
        setIsBalanced(await ExecuteAxios.api('get', `/production-day/check-if-exists-production-day-by-production-id/`, { params: parameters }));
        const product = await ExecuteAxios.api('get', `/production/get-production-detail/`, { params: parameters })
        if (product) {
            setAttributesDetailProductionPanel(product)
            ApplyAttributes.applyAttributes(product, attributeList)
        }

        if (!productionIdSelected || productionIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    const getProductPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={onUpdateProductionIdSelected}
                    idsSelected={productionIdSelecteds}
                    data={recordsProductByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProductionPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postProduction() {
        try {
            setLoadingProductionPanel(true)
            const response = await ExecuteAxios.api('post', `/production/`, {
                productCode: productCode,
                productionOrder: productionOrder,
                quantityPieces: quantityPieces,
                internalMinPerPieces: internalMinPerPieces,
                totalMinutes: totalMinutes,
                dateReceived: dateReceived,
                dateRealReturn: dateRealReturn,
                statusId: statusId,
                pricePerPiece: pricePerPiece,
                observation: observation,
                expectedQuantityPeople: expectedQuantityPeople
            });

            if (response) {
                onUpdateReloadProductionList(true)
            }

            return response;
        } finally {
            setLoadingProductionPanel(false)
        }
    }

    async function putProduction() {
        try {
            setLoadingProductionPanel(true)
            const response = await ExecuteAxios.api('put', `/production/`, {
                id: idProduction,
                productCode: productCode,
                productionOrder: productionOrder,
                quantityPieces: quantityPieces,
                internalMinPerPieces: internalMinPerPieces,
                totalMinutes: totalMinutes,
                dateReceived: dateReceived,
                dateRealReturn: dateRealReturn,
                statusId: statusId,
                pricePerPiece: pricePerPiece,
                observation: observation,
                expectedQuantityPeople: expectedQuantityPeople
            });

            if (response) {
                onUpdateReloadProductionList(true)
            }

            return response;
        } finally {
            setLoadingProductionPanel(false)
        }
    }

    async function deleteProduction() {
        try {
            setLoadingProductionPanel(true)
            const parameters = {
                id: productionIdSelecteds[0]
            };
            const response = await ExecuteAxios.api('delete', `/production/`, { params: parameters });

            if (response) {
                onUpdateProductionIdSelected([])
            }

            return response;
        } finally {
            setLoadingProductionPanel(false)
        }
    }

    const mainProduction = {
        displa: 'flex',
        flexDirection: 'column',
        transition: 'width 1s ease-in-out'
    };

    function getLayoutModal() {
        if (!allowedAdvancedModule) {
            return 'main-modal'
        }

        if (decreaseProductionPanel && (productionIdSelecteds && productionIdSelecteds.length === 1) && !decreaseProductionPanelDay) {
            return 'main-modal two left'
        } else if (decreaseProductionPanelDay) {
            return 'main-modal not-visible'
        } else {
            return 'main-modal'
        }
    }

    function getAllocatedEmployeesButton() {
        if (allowedAdvancedModule) {
            return (
                <Button
                    clickMethod={() => { onUpdateShowEmployesDayAllocatedPanel(true) }}
                    buttonName={'Visualizar alocados'}
                    style={styleAllocatedButton}
                />
            )
        }
    }

    function getDateFilter() {
        return (
            <>
                <ReactDataPickerComp
                    selected={dtStartFilter}
                    onChange={(date) => { setDtStartFilter(date) }}
                    className='cost-fix-width-date cursor-pointer'
                    placeholderText={'Filtro inicial'}
                    dateFormat={'dd/MM/yyyy'}
                    setter={setDtStartFilter}
                />
                <ReactDataPickerComp
                    selected={dtFinishFilter}
                    onChange={(date) => { setDtFinishFilter(date) }}
                    className='cost-fix-width-date cursor-pointer'
                    placeholderText={'Filtro final'}
                    dateFormat={'dd/MM/yyyy'}
                    setter={setDtFinishFilter}
                />
            </>
        )
    }

    function getFilterCode() {
        return (
            <InputField
                placeholder={'Código do produto'}
                setAttribute={setProductCodeFilter}
                value={productCodeFilter}
                style={{ width: '165px' }}
            />
        )
    }

    function getStatusButton() {
        return (
            <ComboBox setAttribute={setStatusFilterSelected}
                optionsData={itemsStatusOptions}
                style={{ width: '150px' }}
                value={statusFilterSelected}
                defaultValue={statusFilterSelected}
                placeholder={'Status'}
            />
        )
    }

    const styleAllocatedButton = {
        width: '150px',
        float: 'right',
        color: 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    function getExternalProductionButton() {
        if (allowedExternalModule && productionIdSelecteds && productionIdSelecteds.length > 0) {
            return (
                <Button
                    clickMethod={() => { onUpdateShowExternalProduction(true) }}
                    buttonName={'Produção externa'}
                    style={styleExternalProductionButton}
                />
            )
        }
    }

    function getCreateProductFromDocumentButton() {
        return (
            <Button
                clickMethod={() => { setShowCreateProductFromDocument(true) }}
                buttonName={'Escanear sequência'}
                title={'Escanear sequência operacional (PDF) e criar o produto'}
                style={{ ...styleExternalProductionButton, width: 'auto', padding: '0px 12px' }}
            />
        )
    }

    const styleExternalProductionButton = {
        width: '150px',
        float: 'right',
        color: 'green',
        fontWeight: '600',
        textAlign: 'center',
        fontSize: '0.8em',
        cursor: 'pointer',
        height: '30px'
    };

    return (
        <Panel style={mainProduction} className={getLayoutModal()}>
            <ExternalProduction
                isOpen={showExternalProduction}
                setIsOpen={onUpdateShowExternalProduction}
                productionsIdSelecteds={productionIdSelecteds}
            />
            <CreateProductFromDocument
                isOpen={showCreateProductFromDocument}
                setIsOpen={setShowCreateProductFromDocument}
            />
            <EmployesDayAllocated
                onUpdateShowEmployesDayAllocatedPanel={onUpdateShowEmployesDayAllocatedPanel}
                showEmployesDayAllocatedPanel={showEmployesDayAllocatedPanel}
            />
            <Panel
                style={productionPanelStyle}
                titlePage={'Produção'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={productionIdSelecteds && productionIdSelecteds.length === 1}
                putFunction={putProduction}
                enableNewRecord={true}
                canNewRecord={true}
                postFunction={postProduction}
                deleteFunction={deleteProduction}
                canDelete={true}
                enableDelete={productionIdSelecteds && productionIdSelecteds.length === 1}
                canViewCRUD={true}
                recordsSelected={productionIdSelecteds}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailProductionPanel}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateProductionIdSelected}
                reloadFilter={onUpdateReloadProductionList}
                componentLeftButtons={[
                    getDateFilter(),
                    getFilterCode(),
                    getStatusButton(),
                    getAllocatedEmployeesButton(),
                    getExternalProductionButton(),
                    getCreateProductFromDocumentButton()
                ]}

                subtitlesPanelBottom={
                    <div style={{ display: 'flex', flexDirection: 'row', height: '5%', width: '100%' }}>
                        {getButtonToShowSubtitles()}
                    </div>}
            >
                <LoadingIndicator loaded={recordsProductByUserId && !loadingProductionPanel}>
                    {getProductPanelListOrDetail()}
                </LoadingIndicator>
            </Panel>
        </Panel >
    );

}

export default Production;